import React from "react";
import { Grid, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

import ProfileBar from "./Components/ProfileBar";
import TabsBar from "./Components/TabsBar";

const useStyles = makeStyles((theme) => ({
  background:{
    backgroundColor: "#ececec",
    height: "100vh",
    width: "100wh",
    padding: 0,
    margin: 0,
  },
  left: {
  },
  right: {
    // width: "100%",
    // position: "relative",
    // top: "70px",
    // paddingTop: "10px",
  },
}));

export default function Dashboard() {
  const classes = useStyles();

  return (
    <div className={classes.background}>
    <Container maxWidth="lg" className={classes.container}>
      <Grid container>
        <Grid item xs={4} className={classes.left}>
          <ProfileBar />
        </Grid>
        <Grid item xs={8} className={classes.right}>
          <TabsBar />
        </Grid>
      </Grid>
    </Container>
    </div>
  );
}
